import React from 'react';
import MuiTab from '@material-ui/core/Tab';

function Tab(props) {
    return (
        <MuiTab
            {...props}
            classes={{
                root: 'filter-tabs__tab-root',
                selected: 'filter-tabs__tab-root--selected',
            }}
        />
    );
}
Tab.muiName = MuiTab.muiName;

export default Tab;
